var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "colorpicker", staticClass: "input-group color-picker" },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.colorValue,
            expression: "colorValue",
          },
        ],
        staticClass: "form-control",
        attrs: { type: "text" },
        domProps: { value: _vm.colorValue },
        on: {
          focus: _vm.showPicker,
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.colorValue = $event.target.value
            },
            _vm.updateFromInput,
          ],
        },
      }),
      _vm._v(" "),
      _vm.colorValue
        ? _c(
            "span",
            { staticClass: "input-group-addon color-picker-container" },
            [
              _c(
                "span",
                {
                  staticClass: "current-color",
                  style: { "background-color": _vm.colorValue },
                  on: { click: _vm.togglePicker },
                },
                [_c("i", { style: { "background-color": _vm.colorValue } })]
              ),
              _vm._v(" "),
              _vm.displayPicker
                ? _c("chrome-picker", {
                    ref: "colorPicker",
                    staticClass: "picker-offset",
                    attrs: { value: _vm.pickerColor },
                    on: { input: _vm.updateFromPicker },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /opt/HistomicsUI/histomicsui/web_client/~/vue-loader/lib/loaders/templateLoader.js?{}!/opt/HistomicsUI/histomicsui/web_client/~/vue-loader/lib?{}!./~/@girder/histomicsui/vue/components/ColorPickerInput.vue?vue&type=template&id=65c96cfc&scoped=true&
// module id = 67
// module chunks = 0